import { createFileRoute } from "@tanstack/react-router";
import Instalar from "@/pages/app/Instalar";

export const Route = createFileRoute("/app/instalar")({
  head: () => ({ meta: [{ title: "Instalar o app | Braussie - Nutri" }] }),
  component: Instalar,
});
